import { WarehouseItem, PrintArea, Model } from "@/models";
import PrintAreaCustomization from "@/models/PrintAreaCustomization";

export default class WarehouseItemCustomization extends Model {

	static type = "warehouseItemCustomizations";

	uuid: string;
	warehouseItem: WarehouseItem;
	printAreaCustomizations: PrintAreaCustomization[];

	addPrintArea(printArea: PrintArea){
	  if(!this.printAreaCustomizations){
			this.printAreaCustomizations = [];
		}
		this.printAreaCustomizations.push(new PrintAreaCustomization({ printArea }));
	}
}
